module.exports = __webpack_public_path__ + "img/Differentiation-LICA_GSE146409.de24218f.png";